import React from 'react';
import { Flex, Box, Row, Divider, ExternalLink, Container } from '../core';
import { useBreakpointIndex } from '@theme-ui/match-media';
import { Logo } from './Logo';
import { Gitbook, Github, Discord, Twitter } from '../icons';

export const Footer = (): JSX.Element => {
  const mobile = useBreakpointIndex() === 0;
  return (
    <Container sx={{ flexDirection: 'column', width: '100%' }}>
      {!mobile && <Divider />}
      <Flex
        sx={{
          flex: 1,
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
          minHeight: '140px',
        }}
      >
        <Flex sx={{ justifyContent: ['center', 'space-between'] }}>
          {!mobile && (
            <Logo
              sx={{ fontSize: [4, 4], filter: 'grayscale(100%) brightness(1)' }}
            />
          )}
          <Row sx={{ alignItems: 'center' }}>
            <ExternalLink
              icon={<Discord />}
              href="https://discord.gg/X8Hh3KYhAu"
            >
              {!mobile && 'Discord'}
            </ExternalLink>
            <Box mx={[2, 3]} />
            <ExternalLink
              icon={<Twitter />}
              href="https://twitter.com/scion_fi/"
            >
              {!mobile && 'Twitter'}
            </ExternalLink>
            <Box mx={[2, 3]} />
            <ExternalLink
              icon={<Github />}
              href="https://github.com/scion-finance/"
            >
              {!mobile && 'Github'}
            </ExternalLink>
            <Box mx={[2, 3]} />
            <ExternalLink icon={<Gitbook />} href="https://docs.scion.finance/">
              {!mobile && 'Docs'}
            </ExternalLink>
          </Row>
        </Flex>
      </Flex>
    </Container>
  );
};
